import React from 'react';

const STATUS_MAP = [
  { keys: ['active', 'enabled', 'paid', 'submitted', 'completed', 'approved', 'open', 'in stock', 'in_stock'],
    bg: 'bg-[#ECFDF3]', text: 'text-[#027A48]' },
  { keys: ['pending', 'unpaid', 'processing', 'draft', 'partial', 'partially_received', 'low stock', 'low_stock', 'in_transit', 'partially_in_transit'],
    bg: 'bg-[#FFFAEB]', text: 'text-[#B54708]' },
  { keys: ['inactive', 'disabled', 'cancelled', 'closed', 'rejected', 'returned', 'overdue', 'expired', 'void', 'out of stock', 'out_of_stock'],
    bg: 'bg-[#FEF3F2]', text: 'text-[#B42318]' },
  { keys: ['now', 'live'],
    bg: 'bg-[#EFF8FF]', text: 'text-[#175CD3]' },
];

function getColors(status) {
  const s = (status || '').toLowerCase().replace(/[\s-]/g, '_');
  for (const { keys, bg, text } of STATUS_MAP) {
    if (keys.some((k) => k.replace(/[\s-]/g, '_') === s || s.includes(k.replace(/[\s-]/g, '_')))) {
      return { bg, text };
    }
  }
  return { bg: 'bg-slate-100', text: 'text-slate-600' };
}

/**
 * Unified status badge — replaces StatusChip everywhere.
 * One component, consistent pill shape + colored dot.
 */
const StatusBadge = ({ status, label, size = 'md', className = '' }) => {
  const { bg, text } = getColors(status);
  const displayLabel = label || status || 'Unknown';
  const isSmall = size === 'sm';

  return (
    <span
      className={[
        'inline-flex items-center whitespace-nowrap rounded-full font-medium',
        isSmall ? 'gap-1 px-2 py-0.5 text-[11px]' : 'gap-1.5 px-2.5 py-0.5 text-xs',
        bg,
        text,
        className,
      ].join(' ')}
    >
      {!isSmall && (
        <span className={`h-1.5 w-1.5 rounded-full opacity-80 ${text.replace('text-', 'bg-')}`} />
      )}
      {displayLabel}
    </span>
  );
};

export default StatusBadge;
